import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import EyeOffOutline from 'mdi-material-ui/EyeOffOutline';
import EyeOutline from 'mdi-material-ui/EyeOutline';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import ConfirmDialog from '../../utils/dialog';


const PasswordChangeDialog = (props) => {
    const {show, setShow, userid, mode, auth} = props
    const [showPassword, setShowPassword] = useState(false)
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setShow(false);
    };

    const handleConfirmClose = () => {
        setOpen(false);
    };

    const handleConfirm = () => {
        setOpen(false);
        auth.logout();
    };

    const {
        control: controlPassword,
        handleSubmit: handleSubmitPassword,
        formState: { errors: errorsPassword },
        reset,
    } = useForm()

    useEffect(() => {
        reset({ staff_password: "" })
    }, [reset, show]);

    const onSubmitPassword = async (data) => {
        const params = {
            "mode": mode == 1 ? 'login' : 'email',
            "newpassword": data.staff_password,
        };

        await apiService.put(`/staff/password/${userid}`, params)
        .then(response => {
            toast.success('비밀번호가 변경 되었습니다.')

            if(mode == 1) {
                setOpen(true)
            }

        }).catch(error => {
            toast.error('비밀번호 변경이 실패했습니다.')
            console.error(error)
        })

        handleClose()
    }

    return (
        <>
            <Dialog open={show} onClose={handleClose}>
                <form key={2} onSubmit={handleSubmitPassword(onSubmitPassword)} id="passwordform">
                    <DialogTitle>{mode == 1 ? '로그인' : '이메일'} 비밀번호 변경</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Alert severity="info">
                                안전한 비밀번호 설정을 위해 <strong>숫자 와 기호</strong>를 혼용해서 사용해주세요
                            </Alert>                    
                        </DialogContentText>
                        <Box sx={{my: 6, px:2}}>
                            <FormControl fullWidth>
                                <Controller
                                    name='staff_password'
                                    control={controlPassword}
                                    rules={{ required: true }}
                                    defaultValue=''
                                    render={({ field: { value, onChange, onBlur } }) => (
                                        <Input
                                            autoFocus
                                            value={value}
                                            label='비밀번호'
                                            id='staff_password'
                                            variant="standard"
                                            onBlur={onBlur}
                                            onChange={onChange}
                                            placeholder='비밀번호를 입력해주세요'
                                            error={Boolean(errorsPassword.staff_password)}
                                            type={showPassword ? 'text' : 'password'}
                                            endAdornment={
                                                <InputAdornment position='end'>
                                                <IconButton
                                                    edge='end'
                                                    onMouseDown={e => e.preventDefault()}
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    {showPassword ? <EyeOutline /> : <EyeOffOutline />}
                                                </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    )}
                                />
                                {errorsPassword.staff_password && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-staff_password'>
                                        비밀번호를 입력해주세요
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>취소</Button>
                        <Button type="submit" form="passwordform" variant='contained'>적용</Button>
                    </DialogActions>
                </form>
            </Dialog>
            <ConfirmDialog 
                open={open}
                title={'Login'}
                content={'관리자 비밀번호 변경으로 인해 Logout을 합니다'}
                handleClose={handleConfirmClose}
                handleConfirm={handleConfirm}
            />
        </>
    );
}

export default PasswordChangeDialog